
				var addMethods = require("../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["cycles","getCycles","getTotalCycles","getScoreInfo"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "825a0cddbf95c22f654e.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			